import React, { Component } from "react";
//
import Screen from "./ConnectedScreen";
import Button from "../components/Button";
import Alert from "../components/Alert";

class ModelAlertScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      duration: 12,
    };
  }

  createAlert() {
    const { duration } = this.state;
    const { model, createModelAlert } = this.props;

    createModelAlert(model.id, duration);
  }

  render() {
    const { duration } = this.state;
    const { model, errorMessage, successMessage } = this.props;

    return (
      <Screen
        title="Receive notification"
        isActive
        nextLabel="Create Alert"
        nextDisabled={successMessage !== null}
        onNext={(ev) => this.createAlert()}
      >
        <p>
          Be notified by email when{" "}
          <span className="u-brand">{model.name}</span> turns online.
        </p>
        <p>Setup alert for the next:</p>
        <div className="u-ml">
          <div className="u-mb-small">
            <label>
              <input
                type="radio"
                name="duration"
                value="12"
                onChange={(ev) => this.setState({ duration: 12 })}
                checked={duration === 12}
              />{" "}
              12h
            </label>
          </div>
          <div className="u-mb-small">
            <label>
              <input
                type="radio"
                name="duration"
                value="24"
                onChange={(ev) => this.setState({ duration: 24 })}
                checked={duration === 24}
              />{" "}
              24h
            </label>
          </div>
          <div className="u-mb">
            <label>
              <input
                type="radio"
                name="duration"
                value="48"
                onChange={(ev) => this.setState({ duration: 48 })}
                checked={duration === 48}
              />{" "}
              48h
            </label>
          </div>
        </div>
        {successMessage !== null && (
          <Alert info className="u-mt" text={successMessage} />
        )}
        {errorMessage !== null && (
          <Alert error className="u-mt" text={errorMessage} />
        )}
      </Screen>
    );
  }
}

// @connect
import { connect } from "react-redux";
import { createModelAlertAction } from "../modules/models/actions";

function mapState(state) {
  return {};
}

function mapDispatch(dispatch) {
  return {
    createModelAlert(modelId, duration) {
      dispatch(createModelAlertAction(modelId, duration));
    },
  };
}

export default connect(
  mapState,
  mapDispatch
)(ModelAlertScreen);
